import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PendingApproval() {
  const { user, loading, signOut } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'ADMIN' || user.status !== 'PENDING') return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-caution/10 flex items-center justify-center">
            <span className="material-symbols-outlined text-caution text-[40px]" style={{ fontVariationSettings: "'FILL' 1" }}>
              hourglass_top
            </span>
          </div>
        </div>

        {/* Copy */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-on-surface">Solicitud en revisión</h1>
          <p className="text-on-surface-variant text-sm leading-relaxed">
            Gracias por completar tu perfil. Tu cuenta está siendo revisada por nuestro equipo.
            Te avisaremos por email en cuanto esté activa.
          </p>
        </div>

        {/* Info card */}
        <div className="bg-surface-container-low rounded-2xl p-6 border border-outline-variant/10 text-left space-y-4">
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-primary text-[20px] shrink-0 mt-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>
              verified_user
            </span>
            <div>
              <p className="text-sm font-semibold text-on-surface">Proceso de verificación</p>
              <p className="text-xs text-on-surface-variant mt-0.5">
                Revisamos cada perfil manualmente para garantizar la mejor experiencia a nuestra comunidad.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-primary text-[20px] shrink-0 mt-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>
              schedule
            </span>
            <div>
              <p className="text-sm font-semibold text-on-surface">Tiempo estimado</p>
              <p className="text-xs text-on-surface-variant mt-0.5">
                Normalmente activamos cuentas dentro de las primeras 24–48 horas hábiles.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-primary text-[20px] shrink-0 mt-0.5" style={{ fontVariationSettings: "'FILL' 1" }}>
              mail
            </span>
            <div>
              <p className="text-sm font-semibold text-on-surface">Notificación por email</p>
              <p className="text-xs text-on-surface-variant mt-0.5">
                Recibirás un email con los próximos pasos en cuanto tu cuenta sea activada.
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={signOut}
          className="text-sm text-on-surface-variant hover:text-on-surface transition-colors underline underline-offset-2"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
